import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndpoints'
import { sitConfig } from './config'

const responseParser = (data: any) => {
  return data
}

const downloadInvoiceReq: any = (tokens: any, mid: string, fileName: string) => {
  const config = sitConfig(tokens)
  const url = `${sitConfig(tokens).baseUrl}/${APIEndPoints.invoice.slice(1)}${mid}/${fileName}`
  const request: Request<{}> = {
    config: config,
    apiPath: url,
    method: 'GET',
    responseType: 'arraybuffer',
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { downloadInvoiceReq }
